import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { slide as Menu } from 'react-burger-menu';
import { compose } from 'redux';
import { css } from 'styled-components';
import styled from 'styled-components/macro';

import {
  DisplayToggle,
  MQ_FOR_DESKTOP_BELOW,
  MQ_FOR_TABLET_LANDSCAPE_BELOW,
  MQ_FOR_TABLET_LANDSCAPE_UP
} from 'web-ui-kit/media';
import BlackChevronDown from './assets/black-chevron-down';
import ModsyLogo from './assets/modsy-logo';

import {
  black,
  lightGrey,
  primaryM,
  primaryHighlightM,
  secondaryHighlightM,
  white
} from 'web-ui-kit/colors';
import { Box, Flex } from 'web-ui-kit/containers';
import { H7, H8, semiBold, regular } from 'web-ui-kit/heading';
import { PrimaryCta, SecondaryCta } from 'web-ui-kit/button';
import { fontFamilyPrimary } from 'web-ui-kit/typography';

import setRetailer from 'shared/actions/retailPartner';

import { logoutUser } from 'redux/User/actions';
import { userIsLoggedIn } from 'redux/User';

import { RETAIL_BANNER_PROJECT_ROUTES } from 'utils/constants/project';

import analytics from 'services/analytics';
import {
  examplesUrl,
  expressHowItWorksUrl,
  expressPricingUrl,
  expressStartProjectUrl,
  faqUrl,
  howItWorksUrl,
  loginUrl,
  logoutUrl,
  pricingUrl,
  startProjectUrl,
  styleQuizUrl,
  designIdeasUrl,
  designIdeasBedroomUrl,
  diningRoomUrl,
  homeOfficeUrl,
  kidsRoomUrl,
  livingRoomUrl,
  onlineVsTraditionalDesignUrl,
  online3DDesignUrl,
  giftCardsUrl,
  blogUrl,
  homeDesignBlogUrl,
  realOnlineInteriorBlogUrl,
  styleIdeasBlogUrl,
  trendsBlogUrl,
  layoutGuidesBlogUrl
} from 'services/routing';

import {
  getSpaceList,
  getIsSpaceListLoading,
  getSpaceListPage,
  requestSpaceList,
  getSpaceUserId
} from 'redux/PPO';

const styles = {
  bmBurgerButton: {
    position: 'absolute',
    width: '26px',
    height: '20px',
    right: '36px',
    top: '14px',
    display: 'block'
  },
  bmBurgerBars: {
    background: '#373a47',
    borderRadius: '20px'
  },
  bmCrossButton: {
    top: '-40px',
    right: '24px',
    background: 'white !important'
  },
  bmCross: {
    opacity: 0,
    background: 'black',
    transition: '.2s',
    transitionProperty: 'opacity',
    height: '24px'
  },
  bmMenu: {
    background: 'white',
    paddingTop: '0',
    fontSize: '16px'
  },
  bmMenuWrap: {
    height: `calc(100% - ${2.5 * 16}px)`,
    width: '100%',
    minWidth: '300px'
  },
  bmMorphShape: {
    fill: '#373a47'
  },
  bmItemList: {
    color: 'black'
  }
};

/**
 * In-App Paths
 * */
const expressHowItWorks = { inAppPath: expressHowItWorksUrl, text: 'How It Works' };
const expressPricing = { inAppPath: expressPricingUrl, text: 'Pricing' };
const startProject = { inAppPath: startProjectUrl, text: 'Start Your Project' };
const expressStartProject = { inAppPath: expressStartProjectUrl, text: 'Start Your Project' };
const logoutLink = { inAppPath: logoutUrl, text: 'Logout' };
const login = { inAppPath: loginUrl, text: 'Login' };

/**
 * Marketing App Paths
 * */
const examples = { href: examplesUrl, text: 'Examples' };
const styleQuiz = { href: styleQuizUrl, text: 'Style Quiz' };
const faq = { href: faqUrl, text: 'FAQ' };
const pricing = { href: pricingUrl, text: 'Pricing' };
const giftCards = { href: giftCardsUrl, text: 'Gift Cards' };

// account link info is created dynamically based on user space list

/**
 * How It Works dropdown links
 */
const howItWorksLinks = [
  { href: howItWorksUrl, text: 'How It Works' },
  { href: onlineVsTraditionalDesignUrl, text: 'Modsy vs. Traditional Designers' },
  { href: online3DDesignUrl, text: 'The Modsy 3D Difference' },
  { href: faqUrl, text: 'Design Service Q&A' }
];

const HOW_IT_WORKS_DROPDOWN_ID = 'howItWorksDropdown';

function HowItWorksDropdown ({ isMobileMenu, onLinkClick }) {
  return (
    <DropdownMenu
      id={HOW_IT_WORKS_DROPDOWN_ID}
      isMobileMenu={isMobileMenu}
      links={howItWorksLinks}
      onLinkClick={onLinkClick}
    />
  );
}

/**
 * Design Ideas dropdown links
 */
const designIdeasLinks = [
  { href: designIdeasUrl, text: 'Design Ideas' },
  { href: designIdeasBedroomUrl, text: 'Bedroom Design Ideas' },
  { href: diningRoomUrl, text: 'Dining Room Design Ideas' },
  { href: homeOfficeUrl, text: 'Home Office Design Ideas' },
  { href: kidsRoomUrl, text: 'Kids Room Design Ideas' },
  { href: livingRoomUrl, text: 'Living Room Design Ideas' }
];

const DESIGN_IDEAS_DROPDOWN_ID = 'designIdeasDropdown';

function DesignIdeasDropdown ({ isMobileMenu, onLinkClick }) {
  return (
    <DropdownMenu
      id={DESIGN_IDEAS_DROPDOWN_ID}
      isMobileMenu={isMobileMenu}
      links={designIdeasLinks}
      onLinkClick={onLinkClick}
    />
  );
}

/**
 * Blog dropdown links
 */
const blogLinks = [
  { href: blogUrl, text: 'Blog' },
  { href: homeDesignBlogUrl, text: 'Tips & Guides' },
  { href: realOnlineInteriorBlogUrl, text: 'Real Stories' },
  { href: styleIdeasBlogUrl, text: 'Style Ideas' },
  { href: trendsBlogUrl, text: 'Decor Trends' },
  { href: layoutGuidesBlogUrl, text: 'Layout Guides' }
];

const BLOG_DROPDOWN_ID = 'blogDropdown';

function BlogDropdown ({ isMobileMenu, onLinkClick }) {
  return (
    <DropdownMenu
      id={BLOG_DROPDOWN_ID}
      isMobileMenu={isMobileMenu}
      links={blogLinks}
      onLinkClick={onLinkClick}
    />
  );
}

function DropdownMenu ({
  id,
  isMobileMenu,
  links,
  onLinkClick
}) {
  const {
    DropdownArrow,
    DropdownItem,
    DropdownMenu,
    Link,
    NavItem
  } = dropdownStyles;
  const [isExpanded, setIsExpanded] = useState(false);
  const handleTopLinkClick = (event) => {
    if (isMobileMenu) {
      // prevent navigating to link href on mobile
      event.preventDefault();
      event.stopPropagation();

      // instead display the dropdown menu
      setIsExpanded(!isExpanded);
    } else {
      onLinkClick({
        event,
        href: links[0].href,
        isExternalLink: true,
        text: links[0].text
      });
    }
  };

  return (
    <NavItem dropdown>
      <TopLinkWrapper
        onMouseEnter={() => !isMobileMenu && setIsExpanded(true)}
        onMouseLeave={() => !isMobileMenu && setIsExpanded(false)}
        onClick={handleTopLinkClick}>
        <Link
          aria-expanded={isExpanded}
          aria-haspopup
          id={id}
          href={links[0].href}
          role='button'
        >
          <LinkText id={`${id}-link-text`}>
            {links[0].text}
          </LinkText>
          <DropdownArrow isExpanded={isExpanded} />
        </Link>
      </TopLinkWrapper>

      <DropdownMenu
        aria-labelledby={id}
        isExpanded={isExpanded}
        onMouseEnter={() => !isMobileMenu && setIsExpanded(true)}
        onMouseLeave={() => !isMobileMenu && setIsExpanded(false)}>
        {links.slice(1).map(({ href, text }) => (
          <DropdownItem
            href={href}
            key={text}
            onClick={event => {
              onLinkClick({ event, href, isExternalLink: true, text });
            }}
          >
            <LinkText>{text}</LinkText>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </NavItem>
  );
}

/**
 * Pre purchase application navbar.
 */
export class PrePurchaseMainAppBar extends Component {
  state = {
    width: window.innerWidth,
    menuOpen: false,
    account: { text: 'My Modsy', href: '/projects' }
  };

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  closeMobileMenu = () => {
    this.setState({ menuOpen: false });
  };

  componentDidMount () {
    const { fetchSpaceList, spaceUserId, spaceListPage } = this.props;

    if (spaceUserId && spaceUserId > 0) {
      fetchSpaceList(spaceUserId, spaceListPage);
    }
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  getRetailPartnerQuery (space) {
    const slug = (space.partnerDetails && space.partnerDetails.slug) || null;
    return slug ? `?prtnr=${slug}` : '';
  }

  handleStateChange = state => {
    this.setState({ menuOpen: state.isOpen });
  }

  isActiveLink (linkUrl) {
    const currentUrl = `${window.location.pathname}${window.location.hash}`;
    return linkUrl === currentUrl ? 'active' : '';
  }

  findLinkByText (links, targetText) {
    return links.find(({text}) => text === targetText);
  }

  removeLink (links, toRemove) {
    if (toRemove) {
      return links.filter(item => item !== toRemove);
    }
    return links;
  }

  moveLinkToEdge (links, toMoveText, toFront) {
    const link = this.findLinkByText(links, toMoveText);
    if (link) {
      const newLinks = this.removeLink(links, link);
      return toFront ? [link, ...newLinks] : [...newLinks, link];
    }
    return links;
  }

  render () {
    const { userIsLoggedIn, location, hasRetailPartnerLogo } = this.props;
    const { account } = this.state;

    const express = this.props.match.path.includes('/express');

    const commonLinks = express
      ? [
        expressHowItWorks,
        expressPricing,
        examples,
        faq
      ]
      : [
        pricing,
        styleQuiz,
        examples,
        giftCards
      ];

    let commonLinksRhs = [];
    if (!window.location.href.includes('login')) {
      commonLinksRhs = [userIsLoggedIn ? logoutLink : login];
    }

    if (userIsLoggedIn) {
      commonLinksRhs.push(account);
    } else if (!userIsLoggedIn && !location.pathname.includes('/project/')) {
      if (express) { commonLinksRhs.push(expressStartProject); } else { commonLinksRhs.push(startProject); }
    }

    const hasRetailBanner = hasRetailPartnerLogo &&
      RETAIL_BANNER_PROJECT_ROUTES.includes(location.pathname);

    // whether or not the mobile dropdown menu is currently displayed
    let isMobileMenu = false;

    // callback fired when user clicks on any regular links
    let onLinkClick = ({ event, href, text }) => {};

    return (
      <Fixed className={hasRetailBanner && 'has-retail-partner-banner'}>
        <DisplayToggle query={'(min-width: 1110px)'}>
          {this.renderMobileAppBar([...commonLinks], [...commonLinksRhs], express, isMobileMenu, onLinkClick)}
          {this.renderDesktopAppBar([...commonLinks], [...commonLinksRhs], express, isMobileMenu, onLinkClick)}
        </DisplayToggle>
      </Fixed>
    );
  }

  renderMobileAppBar (commonLinks, commonLinksRhs, express, isMobileMenu, onLinkClick) {
    const { userIsLoggedIn } = this.props;
    const onHomePage = this.props.location.pathname === '/';
    let links = [
      ...onHomePage ? [] : [{ inAppPath: '/', text: 'HOME' }],
      ...commonLinks,
      ...commonLinksRhs
    ];

    let accountLink = null;
    let accountLinkItem = null;
    let startLink = this.findLinkByText(links, 'Start Your Project');
    isMobileMenu = true;
    links = this.removeLink(links, startLink);
    if (userIsLoggedIn) {
      // account link will always be last in list when logged in
      accountLink = links[links.length - 1];
      links = this.removeLink(links, accountLink);
      const accountLinkTo = accountLink.inAppPath ? accountLink.inAppPath : accountLink.href;
      accountLinkItem = (
        <MobileCtaLink href={accountLinkTo}
          onClick={() => {
            this.closeMobileMenu();
            this.props.headerClick(accountLink.text);
          }}>
          <MobileLinkSecondaryCta>
            {accountLink.text}
          </MobileLinkSecondaryCta>
        </MobileCtaLink>
      );
    } else {
      links = this.moveLinkToEdge(links, 'Login', true);
    }

    // determines to show close button or hamburger button for mobile menu
    styles.bmBurgerButton.display = this.state.menuOpen ? 'none' : 'block';
    styles.bmCross.opacity = this.state.menuOpen ? 1 : 0;
    styles.bmCross.transitionDelay = this.state.menuOpen ? '.2s' : '0s';
    return (
      <div>
        <LogoContainer
          onClick={() => {
            this.props.headerClick('Modsy Logo');
            window.location.href = express ? '/express' : '/';
          }}
        >
          <ModsyLogo />
        </LogoContainer>
        <MobileMenu
          isOpen={this.state.menuOpen}
          onStateChange={this.handleStateChange}
          pageWrapId={'page-wrap'}
          outerContainerId={'outer-container'}
          styles={styles}
        >
          {accountLinkItem}
          {startLink && (
            <MobileCtaLink href={startLink.inAppPath}
              onClick={() => {
                this.closeMobileMenu();
                this.props.headerClick(startLink.text);
              }}>
              <MobileLinkPrimaryCta>
                {startLink.text}
              </MobileLinkPrimaryCta>
            </MobileCtaLink>
          )}
          <HowItWorksDropdown isMobileMenu={isMobileMenu} onLinkClick={onLinkClick} />
          {links.map((link, index) => {
            return (
              <div key={index}>
                {index === 3 &&
                  // Index equals three to ensure the following order for the header:
                  // How it works | Pricing | Style Quiz | Examples | Design Ideas | Blog | Gift Cards
                  <div>
                    <DesignIdeasDropdown isMobileMenu={isMobileMenu} onLinkClick={onLinkClick} />
                    <BlogDropdown isMobileMenu={isMobileMenu} onLinkClick={onLinkClick} />
                  </div>
                }
                {link.inAppPath ? (
                  <InAppLink
                    className={[
                      'mobile-link',
                      link.text
                        .toLowerCase()
                        .replace(/ /g, '-'),
                      this.isActiveLink(link.inAppPath)
                    ].join(' ')}
                    key={index}
                    to={link.inAppPath}
                  >
                    <MenuItem
                      onClick={() => {
                        this.closeMobileMenu();
                        if (link.text === 'Logout') {
                          return this.props.dispatch(logoutUser());
                        }
                        this.props.headerClick(link.text);
                      }}
                    >
                      {link.text}
                    </MenuItem>
                  </InAppLink>
                ) : (
                  <ExternalLink
                    className={[
                      'mobile-link',
                      link.text
                        .toLowerCase()
                        .replace(/ /g, '-'),
                      this.isActiveLink(link.inAppPath)
                    ].join(' ')}
                    key={index}
                    href={link.href}
                  >
                    <MenuItem
                      onClick={() => {
                        this.closeMobileMenu();
                        if (link.text === 'LOGOUT') {
                          return this.props.dispatch(logoutUser());
                        }
                        this.props.headerClick(link.text);
                      }}
                    >
                      {link.text}
                    </MenuItem>
                  </ExternalLink>
                )}
              </div>);
          })}
        </MobileMenu>
      </div>
    );
  }

  renderDesktopAppBar (links, commonLinksRhs, express, isMobileMenu, onLinkClick) {
    const { userIsLoggedIn } = this.props;
    let rhsLinks = [...commonLinksRhs];
    let accountLink = null;
    let accountLinkItem = null;
    let startProjectLink = null;
    if (userIsLoggedIn) {
      accountLink = rhsLinks[rhsLinks.length - 1];
      rhsLinks = this.removeLink(rhsLinks, accountLink);
      const accountLinkTo = accountLink.inAppPath ? accountLink.inAppPath : accountLink.href;
      accountLinkItem = (
        <DesktopCtaLink href={accountLinkTo} onClick={() => {
          this.props.headerClick(accountLink.text);
        }}>
          <DesktopLinkSecondaryCta>
            {accountLink.text}
          </DesktopLinkSecondaryCta>
        </DesktopCtaLink>
      );
    } else {
      // Show start project link if it exists
      startProjectLink = this.findLinkByText(rhsLinks, 'Start Your Project');
      rhsLinks = this.removeLink(rhsLinks, startProjectLink);
    }
    return (
      <Header>
        <LogoFlex
          onClick={() => {
            this.props.headerClick('Modsy Logo');
            window.location.href = express ? '/express' : '/';
          }}
        >
          <ModsyLogo />
        </LogoFlex>

        <NavLinksContainer>
          <Links className='link-bar-left'>
            <HowItWorksDropdown isMobileMenu={isMobileMenu} onLinkClick={onLinkClick} />
            {links.map((link, index) => {
              if (link.text === 'LOGOUT') {
                return (
                  <LinkContainer key={index}>
                    <div
                      to={link.inAppPath}
                      onClick={() => {
                        if (link.text === 'LOGOUT') {
                          return this.props.dispatch(logoutUser());
                        }
                        this.props.headerClick(link.text);
                      }}
                    >
                      <H8>{link.text}</H8>
                    </div>
                  </LinkContainer>
                );
              }
              return (
                <React.Fragment key={index}>
                  {index === 3 &&
                    // Index equals three to ensure the following order for the header:
                    // How it works | Pricing | Style Quiz | Examples | Design Ideas | Blog | Gift Cards
                    <NavWrapperLastItems>
                      <DesignIdeasDropdown isMobileMenu={isMobileMenu} onLinkClick={onLinkClick} />
                      <BlogDropdown isMobileMenu={isMobileMenu} onLinkClick={onLinkClick} />
                    </NavWrapperLastItems>
                  }
                  <LinkContainer key={index}>
                    {link.inAppPath ? (
                      <InAppLink
                        className={this.isActiveLink(link.inAppPath)}
                        to={link.inAppPath}
                        onClick={() => {
                          this.props.headerClick(link.text);
                        }}
                      >
                        <LinkText>
                          {link.text}
                        </LinkText>
                      </InAppLink>
                    ) : (
                      <ExternalLink
                        className={this.isActiveLink(link.inAppPath)}
                        href={link.href}
                        onClick={() => {
                          this.props.headerClick(link.text);
                        }}
                      >
                        <LinkText>
                          {link.text}
                        </LinkText>
                      </ExternalLink>
                    )}
                  </LinkContainer>
                </React.Fragment>
              );
            })}
          </Links>

          <Links className='link-bar-right'>
            {rhsLinks.map((link, index) => {
              if (link.text === 'LOGOUT') {
                return (
                  <LinkContainer key={index}>
                    <div
                      to={link.inAppPath}
                      onClick={() => {
                        if (link.text === 'LOGOUT') {
                          return this.props.dispatch(logoutUser());
                        }
                        this.props.headerClick(link.text);
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <H8>{link.text}</H8>
                    </div>
                  </LinkContainer>
                );
              }
              return (
                <LinkContainer key={index}>
                  {link.inAppPath ? (
                    <InAppLink
                      className={[
                        link.text.toLowerCase().replace(/ /g, '-'),
                        this.isActiveLink(link.inAppPath)
                      ].join(' ')}
                      to={link.inAppPath}
                      onClick={() => {
                        this.props.headerClick(link.text);
                      }}
                    >
                      <H8>{link.text}</H8>
                    </InAppLink>
                  ) : (
                    <ExternalLink
                      className={[
                        link.text.toLowerCase().replace(/ /g, '-'),
                        this.isActiveLink(link.inAppPath)
                      ].join(' ')}
                      href={link.href}
                      onClick={() => {
                        this.props.headerClick(link.text);
                      }}
                    >
                      <H8>{link.text}</H8>
                    </ExternalLink>
                  )}
                </LinkContainer>
              );
            })}
            {accountLinkItem}
            {startProjectLink && (
              <DesktopCtaLink href={startProjectLink.inAppPath} onClick={() => {
                this.props.headerClick(startProjectLink.text);
              }}>
                <DesktopLinkPrimaryCta>
                  {startProjectLink.text}
                </DesktopLinkPrimaryCta>
              </DesktopCtaLink>
            )}
          </Links>
        </NavLinksContainer>
      </Header>
    );
  }
}

const mapStateToProps = state => ({
  userIsLoggedIn: userIsLoggedIn(state),
  spaceList: getSpaceList(state),
  spaceListLoading: getIsSpaceListLoading(state),
  spaceListPage: getSpaceListPage(state),
  spaceUserId: getSpaceUserId(state),
  hasRetailPartnerLogo: state.retailPartner && !!state.retailPartner.logo
});

const mapDispatchToProps = dispatch => ({
  headerClick: linkName => dispatch(analytics.headerClick({ linkName })),
  fetchSpaceList: (userId, spaceListPage) => dispatch(requestSpaceList(userId, spaceListPage)),
  setRetailer: partner => dispatch(setRetailer(partner)),
  dispatch
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withRouter, withConnect)(
  PrePurchaseMainAppBar
);

const Fixed = styled.div`
  position: fixed;
  background-color: white;
  border-bottom: .75px solid ${lightGrey};
  width: 100%;
  top: 0;
  z-index: 9999;

  &.has-retail-partner-banner {
    top: 55px;
  }
`;

const Header = styled(Flex)`
  flex-direction: row;
  align-items: center;

  height: 64px;
  width: 100%;
  top: 0;
`;
Header.displayName = 'Header';

const MenuItem = styled(Box)`
  display: flex;
  color: ${primaryM};
  font-weight: ${semiBold};
  font-family: ${fontFamilyPrimary};
  font-size: 14px;
  line-height: 18px;
  color: #41434A;
  padding: 20px 16px;
`;
MenuItem.displayName = 'MenuItem';

const LogoContainer = styled(Box)`
  width: 130px;
  padding: 16px;
`;
LogoContainer.displayName = 'LogoContainer';

const LinkContainer = styled(Box)`
  white-space: nowrap;  
  padding: 0 12px;
`;
LinkContainer.displayName = 'LinkContainer';

const LinkText = styled(H7)`
  display: flex;
  color: ${primaryM};
  font-weight: ${semiBold};
  font-family: ${fontFamilyPrimary};
  font-size: 14px;
  line-height: 18px;
  color: #41434A;

  ${MQ_FOR_TABLET_LANDSCAPE_UP} {
    &:hover {
      color: ${primaryM} !important;
    }
  }
`;
LinkText.displayName = 'LinkText';

const NavLinksContainer = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-right: 32px;
`;
NavLinksContainer.displayName = 'NavLinksContainer';

const NavWrapperLastItems = styled(Flex)`
`;
NavWrapperLastItems.displayName = 'NavWrapperLastItems';

const MobileMenu = styled(Menu)`
  text-transform: uppercase;
`;

/**
 * Mobile Container Link for Primary and Secondary CTA Buttons
 */
const MobileCtaLink = styled.a`
  display: block;
  position: relative;
  height: 40px;
  margin: 44px 32px 22px;
`;

/**
 * CSS Modifier for Mobile SecondaryCta from web-ui-kit
 */
const MobileLinkSecondaryCta = styled(SecondaryCta)`
  color: ${primaryM};
  border-color: ${primaryM}; 
  max-width: none;
  height: 40px;
  padding: 0;
  border-radius: 4px;
  border: 1px solid ${secondaryHighlightM};

  &:hover {
    color: ${primaryHighlightM};
    border-color: ${primaryHighlightM} !important;
  }
`;

/**
 * CSS Modifier for Mobile PrimaryCta from web-ui-kit
 */
const MobileLinkPrimaryCta = styled(PrimaryCta)`
  background-color: ${primaryM};
  border-radius: 4px;
  border: 1px solid ${primaryM};
  max-width: none;
  height: 40px;
  padding: 0;
  
  &:hover {
    background-color: ${primaryHighlightM} !important;
    border-color: ${primaryHighlightM} !important;
  }
`;

const Links = styled(Flex)`
  flex-direction: row;
  align-items: center;
  ${props => props.ml && `margin-left: ${props.ml}px;`}
`;
Links.displayName = 'Links';

/**
 * Desktop Container Link for Primary and Secondary CTA Buttons
 */
const DesktopCtaLink = styled.a`
  margin-right: 16px;
`;

/**
 * CSS Modifier for Desktop SecondaryCta from web-ui-kit
 */
const DesktopLinkSecondaryCta = styled(SecondaryCta)`
  color: ${primaryM};
  border-color: ${primaryM} !important;
  border-radius: 4px;
  box-sizing: content-box;
  font-size: 14px;
  font-weight: ${regular};
  height: 40px;
  width: auto;
  padding: 0 24px;

  &:hover {
    color: ${primaryHighlightM};
    background-color: #F9E7EA !important;
    border-color: ${primaryHighlightM} !important;
  }
`;

/**
 * CSS Modifier for Desktop PrimaryCta from web-ui-kit
 */
const DesktopLinkPrimaryCta = styled(PrimaryCta)`
  box-sizing: content-box;
  background-color: ${primaryM};
  border-radius: 4px;
  border: 1px solid ${primaryM};
  font-size: 14px;
  font-weight: ${regular};
  height: 40px;
  width: auto;
  padding: 0 24px;
  
  &:hover {
    background-color: ${primaryHighlightM} !important;
    border-color: ${primaryHighlightM} !important;
  }
`;

/**
 * Styling for in-app links.
 */
const InAppLink = styled(HashLink)`
  color: ${black};
  text-decoration: none;
  
  ${MQ_FOR_TABLET_LANDSCAPE_UP} {
    &.active {
      color: ${primaryHighlightM};
    }
    &:hover {
      color: ${primaryM};
    }
  }
`;

/**
 * Styling for external links.
 */
const ExternalLink = styled.a`
  color: ${black};
  cursor: pointer;
  text-decoration: none;
  ${MQ_FOR_TABLET_LANDSCAPE_UP} {
    &.active {
      color: ${primaryHighlightM};
    }
    &:hover {
      color: ${primaryM};
    }
  }
`;
ExternalLink.displayName = 'ExternalLink';

const LogoFlex = styled(Flex)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 22px;
  text-decoration: none;
  flex-direction: row;
  border-right: 1px solid ${lightGrey};
`;
LogoFlex.displayName = 'LogoFlex';

const TopLinkWrapper = styled(Flex)`
`;
TopLinkWrapper.displayName = 'TopLinkWrapper';

const linkStyles = css`
  background-color: ${white};
  cursor: pointer;
  display: flex;
  text-decoration: none;
  white-space: nowrap;
  padding: 1.25rem 1rem;
  width: 100%;


  ${MQ_FOR_TABLET_LANDSCAPE_UP} {
    @media (hover: hover) {
      &:hover {
        ${LinkText} {
          color: ${primaryM};
          svg path {
            fill: ${primaryM};
          }
        }
      }
    }
  }

  ${MQ_FOR_DESKTOP_BELOW} {
    margin: 0;
    -webkit-tap-highlight-color: transparent;

    &:active {
      ${LinkText} {
        color: ${primaryM};
        svg path {
          stroke: ${primaryM};
        }
      }
    }
  }
`;

const dropdownStyles = {
  NavItem: styled.div`
    list-style: none;
    width: 100%;

    ${props => props.dropdown && `
      position: relative;

      ${MQ_FOR_TABLET_LANDSCAPE_UP} {
        &:hover {
          ${dropdownStyles.DropdownMenu} {
            display: flex;
          }
        }
      }
    `}
  `,
  Link: styled.a`
    ${linkStyles};
  `,
  DropdownArrow: styled(BlackChevronDown)`
    align-self: center;
    margin-left: 0.25rem;
    margin-top: 0.0625rem;
    width: 0.5625rem;

    ${props => props.isExpanded && `
      transform: rotateZ(180deg);
    `}

    ${MQ_FOR_DESKTOP_BELOW} {
      width: 0.6875rem;
    }
  `,
  DropdownMenu: styled.div`
    display: none;
    position: absolute;
    flex-direction: column;
    flex-wrap: nowrap;
    
    ${props => props.isExpanded && `
      position: absolute;
      top: calc(100% + 1px);
      left: 0;
      z-index: 1000; /* matches WP homepage z-index */

      box-shadow:
        0px 1px 5px rgba(0, 0, 0, 0.2),
        0px 3px 4px rgba(0, 0, 0, 0.12),
        0px 2px 4px rgba(0, 0, 0, 0.14);
      
      ${MQ_FOR_TABLET_LANDSCAPE_BELOW} {
        display: flex;
        width: 100%;
        position: relative;
        padding-left: 16px
      }
    `}
  `,
  DropdownItem: styled.a`
    ${linkStyles}
    padding-left: 8px;
    padding-right: 30px !important;
  `
};
